import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import styled from 'styled-components';
import { Box } from "@mui/material";
import TextButton from "components/TextButton";
import FormField from "components/FormField";
import TooltipIconButton from "components/TooltipIconButton";
import SidebarHeader from "../layout/SidebarHeader";
import { DeleteOutline } from "@mui/icons-material";
import { v4 as uuidv4 } from 'uuid';
import useProjectStore from "../../../store-zustand/project"

const Header = styled.div`
  margin: 0 0 20px;
  display: flex;
  align-items: center;
  justify-content: space-between;

  h2 {
    font-size: 18px;
    line-height: 22px;
    color: #E5E5E5;
    font-weight: 400;
  }
`;

const Description = styled.p`
  font-family: Open Sans;
  font-weight: 500;
  font-size: 12px;
  line-height: 16px;
  color: #C4C4C4;
  margin-bottom: 20px;

  span {
    font-style: italic;
    font-weight: 300;
  }
`;

const TokenList = styled.div`
  h3 {
    font-family: Roboto;
    font-weight: 400;
    font-size: 18px;
    line-height: 21px;
    color: #E5E5E5;
    margin-bottom: 10px;
  }

  .header-box {
    border-top: 1px solid #A0A0A0;
    border-bottom: 1px solid #A0A0A0;

    .token-name {
      width: 30%;
      font-weight: 400;
      font-size: 9px;
      line-height: 11px;
      color: #C4C4C4;
    }

    .token-permission {
      width: 55%;
      font-weight: 400;
      font-size: 9px;
      line-height: 11px;
      color: #C4C4C4;
      text-align: right;
    }

    .actions {
      width: 15%;
      display: flex;
      align-items: center;
      justify-content: center;

      svg {
        font-size: 1.4rem !important;
      }
    }
  }

  .token-item {
    border-bottom: 1px solid #A0A0A0;
    color: #C4C4C4;

    &.disabled {
      color: #707173;
    }

    .token-name {
      width: 30%;
      font-weight: 400;
      font-size: 9px;
      line-height: 11px;
    }

    .token-permission {
      width: 55%;
      font-weight: 400;
      font-size: 9px;
      line-height: 11px;
      text-align: right;
    }

    .actions {
      width: 15%;
      display: flex;
      align-items: center;
      justify-content: center;
    }
  }
`;

const CesiumIon = ({ goToProfilePage }) => {
  const { addIonKey, getUserOrgIonKeys, deleteIonKeys } = useProjectStore();

  const [tokenList, setTokenList] = useState([
    // { id: uuidv4(), name: 'Default', permission: 'asset:read, asset:list, asset:write', key: '' }
  ]);

  const [newToken, setNewToken] = useState({
    name: '',
    key: ''
  });

  const [selectedTokenIDs, setSelectedTokenIDs] = useState([]);

  const saveToken = () => {

    addIonKey(newToken.name, newToken.key).then((id) => {
      getKeys();
    });
  };

  const handleChange = (e, name) => {
    setNewToken({ ...newToken, [name]: e.target.value });
  };

  const handleChangeToken = (id) => {
    if (selectedTokenIDs.includes(id)) {
      setSelectedTokenIDs(selectedTokenIDs.filter(uid => uid !== id))
    } else {
      setSelectedTokenIDs([...selectedTokenIDs, id]);
    }
  };

  const getKeys = () => {
    var tokens = [];
    getUserOrgIonKeys().then((response) => {
      response?.keys?.map((key) => {
        const token = { id: key.id, name: key.TokenName, key: key.TokenKey, permission: 'asset:read' };
        tokens.push(token);
      })
      setTokenList(tokens);
      setSelectedTokenIDs([]);
    })
  }

  useEffect(() => {
    getKeys();
  }, [])

  const deleteSelected = () => {
    deleteIonKeys(selectedTokenIDs).then(() => {
      getKeys();
    })
  }

  return (
    <>
      <SidebarHeader onClose={goToProfilePage} />
      <Header>
        <h2>Cesium Ion</h2>
        <TextButton onClick={saveToken} text="CONNECT" />
      </Header>
      <FormField label="Token Name" id="token-name">
        <input
          id="token-name"
          type="text"
          placeholder="Token Name"
          value={newToken.name}
          onChange={(e) => handleChange(e, 'name')}
        />
      </FormField>
      <FormField label="Token Key" id="token-key">
        <input
          id="token-key"
          type="text"
          placeholder="Token Key"
          value={newToken.key}
          onChange={(e) => handleChange(e, 'key')}
        />
      </FormField>
      <Description>
        Generate your token at <Link to={{ pathname: 'https://cesium.com/ion/tokens' }} className={'link-underline'} target="_blank">https://cesium.com/ion/tokens</Link> with the following permissions:
        <span> asset:read, asset:list, asset:write</span>
      </Description>
      <TokenList>
        <h3>Tokens</h3>
        <Box display="flex" alignItems="center" justifyContent="space-between" className="header-box" padding="7px">
          <div className="token-name">TOKEN NAME</div>
          {/* <div className="token-permission">PERMISSIONS</div> */}
          <div className="actions">
            <TooltipIconButton title="Delete Token" ariaLabel="delete-team" placement="right" size={24} onClick={deleteSelected} >
              <DeleteOutline fontSize="small" />
            </TooltipIconButton>
          </div>
        </Box>
        {tokenList.map((token, index) => (
          <Box display="flex" alignItems="center" justifyContent="space-between" className="token-item" padding="7px" key={index}>
            <div className="token-name">{token.name}</div>
            {/* <div className="token-permission">{token.permission}</div> */}
            <div className="actions custom-checkbox">
              <input
                type="checkbox"
                id={`checkbox-` + index}
                checked={selectedTokenIDs.includes(token.id)}
                onChange={() => handleChangeToken(token.id)}
              />
              <label htmlFor={`checkbox-` + index} />
            </div>
          </Box>
        ))}
      </TokenList>
    </>
  );
};

export default CesiumIon;
